import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PageContentBox, ContentBox } from '../../components/element';
import { PageTitleBox } from '../../components/menu';
import { PageNavBar } from '../../components/page';
import { VideoBox } from '../../components/video';
import { getTechDocAction, toggleSideMenu } from '../../actions';
import Strings from '../../locales/Strings';
import { getQueryStringValues, validateSelectors } from '../../utils/withPath';
import { TechDocContent } from '../pages';
import { getDownloadInstallationGuideUrl, getPageContentReducerKey } from '../../utils/utils';
import {
  MODEL_ALLETRAMP,
  ALLETRAMP_OPT_BLUETOOTH,
  PAGENAME_CONNECTARRAY_BLUETOOTH,
  PAGENAME_CONNECTARRAY,
  PAGENAME_SETUPARRAY_BLUETOOTH,
  PAGENAME_SETUPARRAY,
  HPE_SIMPLIVITY,
  PAGENAME_INSTALLBRACKETS_SIMPLIVITY325,
  PAGENAME_INSTALLBRACKETS_SIMPLIVITY380,
  PAGENAME_INSTALLBRACKETS_SIMPLIVITY380PLUS,
  PAGENAME_INSTALLSERVER_SIMPLIVITY325,
  PAGENAME_INSTALLSERVER_SIMPLIVITY380,
  PAGENAME_INSTALLSERVER_SIMPLIVITY380PLUS,
  PAGENAME_POWERON_SIMPLIVITY325,
  PAGENAME_POWERON_SIMPLIVITY380,
  PAGENAME_POWERON_SIMPLIVITY380PLUS,
  PAGENAME_CONFIGUREILO_SIMPLIVITY325,
  PAGENAME_CONFIGUREILO_SIMPLIVITY380,
  PAGENAME_CONNECTTOILO_SIMPLIVITY325,
  PAGENAME_CONNECTTOILO_SIMPLIVITY380,
  SIMPLIVITY_OPT_380GEN,
  SIMPLIVITY_OPT_380GEN_PLUS,
  PAGENAME_CONFIGSWITCH,
  PAGENAME_CONFIGSWITCH_EXISTENV,
  NEW_ESXI_CLUSTER,
  PAGENAME_PREPARE_ENV,
  PAGENAME_PREPARE_ENV_EXISTENV,
  PAGENAME_ARRAY_DISCOVERY,
  PAGENAME_ARRAY_DISCOVERY_EXISTENV,
  PAGENAME_SETUPARRAY_EXISTENV,
  PAGENAME_INSTALLBRACKETS_SIMPLIVITY325_GEN11,
  PAGENAME_POWERON_SIMPLIVITY325_GEN11,
  SIMPLIVITY_OPT_325GEN11,
  PAGENAME_CONFIGUREILO_SIMPLIVITY325_GEN11,
  PAGENAME_CONNECTTOILO_SIMPLIVITY325_GEN11,
  PAGENAME_INSTALLSERVER_SIMPLIVITY325_GEN11,
  SIMPLIVITY_OPT_380GEN11,
  PAGENAME_INSTALLBRACKETS_SIMPLIVITY380_GEN11,
  PAGENAME_INSTALLSERVER_SIMPLIVITY380_GEN11,
  PAGENAME_POWERON_SIMPLIVITY380_GEN11,
  PAGENAME_CONFIGUREILO_SIMPLIVITY380_GEN11,
  PAGENAME_CONNECTTOILO_SIMPLIVITY380_GEN11,
  PRODUCT_ID_NIMBLE,
  PRODUCT_ID_ALLETRA,
  PRODUCT_ID_BAAS,
  MODEL_LIST_PCBE,
  PRODUCT_ID_ALLETRAB10K,
} from '../../constants';
const gettingStartedPath = '/getting-started';

export default function TechDocPage(props) {
  const history = props.history;
  const location = props.location;

  const dispatch = useDispatch();
  const queryStringValues = getQueryStringValues(props.location);

  const [arrayModel] = useState(queryStringValues.model);
  const [pageProps] = useState(props.pageProps);
  const [downloadFullDocUrl, setDownloadFullDocUrl] = useState('');
  const [downloadFullDocLabel, setDownloadFullDocLabel] = useState('');
  let pageName = pageProps.pageName;
  const connectopt = queryStringValues['connectopt'];
  const simplivitymodel = queryStringValues['simplivitymodel'];
  const hpeAlletraDHCImodel = queryStringValues['hpeAlletraDHCImodel'];
  const productName = queryStringValues['product'];
  const productsSoftwareConfigPage = [PRODUCT_ID_ALLETRAB10K, PRODUCT_ID_NIMBLE, PRODUCT_ID_ALLETRA, PRODUCT_ID_BAAS];
  switch (pageName) {
    case PAGENAME_CONNECTARRAY:
      if (productName === PRODUCT_ID_ALLETRAB10K && connectopt === ALLETRAMP_OPT_BLUETOOTH) {
        pageName = PAGENAME_CONNECTARRAY_BLUETOOTH;
      }
      break;
    case PAGENAME_SETUPARRAY:
      if (productName === PRODUCT_ID_ALLETRAB10K && connectopt === ALLETRAMP_OPT_BLUETOOTH) {
        pageName = PAGENAME_SETUPARRAY_BLUETOOTH;
      } else if (
        arrayModel === MODEL_ALLETRAMP ||
        productsSoftwareConfigPage.includes(productName) ||
        (MODEL_LIST_PCBE.includes(arrayModel) && hpeAlletraDHCImodel === NEW_ESXI_CLUSTER)
      ) {
        pageName = PAGENAME_SETUPARRAY;
      } else {
        pageName = PAGENAME_SETUPARRAY_EXISTENV;
      }
      break;
    case PAGENAME_INSTALLBRACKETS_SIMPLIVITY325:
      if (arrayModel === HPE_SIMPLIVITY) {
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN) {
          pageName = PAGENAME_INSTALLBRACKETS_SIMPLIVITY380;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
          pageName = PAGENAME_INSTALLBRACKETS_SIMPLIVITY380PLUS;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
          pageName = PAGENAME_INSTALLBRACKETS_SIMPLIVITY325_GEN11;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
          pageName = PAGENAME_INSTALLBRACKETS_SIMPLIVITY380_GEN11;
        }
      }
      break;
    case PAGENAME_INSTALLSERVER_SIMPLIVITY325:
      if (arrayModel === HPE_SIMPLIVITY) {
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN) {
          pageName = PAGENAME_INSTALLSERVER_SIMPLIVITY380;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
          pageName = PAGENAME_INSTALLSERVER_SIMPLIVITY380PLUS;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
          pageName = PAGENAME_INSTALLSERVER_SIMPLIVITY325_GEN11;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
          pageName = PAGENAME_INSTALLSERVER_SIMPLIVITY380_GEN11;
        }
      }
      break;
    case PAGENAME_POWERON_SIMPLIVITY325:
      if (arrayModel === HPE_SIMPLIVITY) {
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN) {
          pageName = PAGENAME_POWERON_SIMPLIVITY380;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
          pageName = PAGENAME_POWERON_SIMPLIVITY380PLUS;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
          pageName = PAGENAME_POWERON_SIMPLIVITY325_GEN11;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
          pageName = PAGENAME_POWERON_SIMPLIVITY380_GEN11;
        }
      }
      break;
    case PAGENAME_CONFIGUREILO_SIMPLIVITY325:
      if (arrayModel === HPE_SIMPLIVITY) {
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN || simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
          pageName = PAGENAME_CONFIGUREILO_SIMPLIVITY380;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
          pageName = PAGENAME_CONFIGUREILO_SIMPLIVITY325_GEN11;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
          pageName = PAGENAME_CONFIGUREILO_SIMPLIVITY380_GEN11;
        }
      }
      break;
    case PAGENAME_CONNECTTOILO_SIMPLIVITY325:
      if (arrayModel === HPE_SIMPLIVITY) {
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN || simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
          pageName = PAGENAME_CONNECTTOILO_SIMPLIVITY380;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
          pageName = PAGENAME_CONNECTTOILO_SIMPLIVITY325_GEN11;
        }
        if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
          pageName = PAGENAME_CONNECTTOILO_SIMPLIVITY380_GEN11;
        }
      }
      break;
    case PAGENAME_CONFIGSWITCH:
      if (MODEL_LIST_PCBE.includes(arrayModel) && hpeAlletraDHCImodel === NEW_ESXI_CLUSTER) {
        pageName = PAGENAME_CONFIGSWITCH;
      } else {
        pageName = PAGENAME_CONFIGSWITCH_EXISTENV;
      }
      break;
    case PAGENAME_PREPARE_ENV:
      if (
        arrayModel === MODEL_ALLETRAMP ||
        (MODEL_LIST_PCBE.includes(arrayModel) && hpeAlletraDHCImodel === NEW_ESXI_CLUSTER)
      ) {
        pageName = PAGENAME_PREPARE_ENV;
      } else {
        pageName = PAGENAME_PREPARE_ENV_EXISTENV;
      }
      break;
    case PAGENAME_ARRAY_DISCOVERY:
      if (
        arrayModel === MODEL_ALLETRAMP ||
        productsSoftwareConfigPage.includes(productName) ||
        (MODEL_LIST_PCBE.includes(arrayModel) && hpeAlletraDHCImodel === NEW_ESXI_CLUSTER)
      ) {
        pageName = PAGENAME_ARRAY_DISCOVERY;
      } else {
        pageName = PAGENAME_ARRAY_DISCOVERY_EXISTENV;
      }
      break;
    default:
      break;
  }

  const pageOpt = queryStringValues['opt'];
  const videoUrl = pageProps[`videoUrl_${pageOpt}`] ? pageProps[`videoUrl_${pageOpt}`] : pageProps['videoUrl'];

  !arrayModel && history.replace(gettingStartedPath);

  const modelList = useSelector(props => props.techDocReducer['modelList']);
  const reducerKey = getPageContentReducerKey({ pageName, model: arrayModel });
  let mdString = useSelector(props => props.techDocReducer[reducerKey]);
  mdString = mdString ? mdString : '';

  useEffect(() => {
    // if (typeof modelList === 'undefined') {
    //   getArrayModelListAction(productName, dispatch);
    //   return;
    // }
    if (modelList && Object.keys(modelList).length > 0 && validateSelectors({ location, history, modelList })) {
      const modelDocConfig = modelList[arrayModel];
      const downloadDocObj = getDownloadInstallationGuideUrl({
        productName: modelDocConfig.productId,
        pageOpt,
        simplivitymodel,
        hpeAlletraDHCImodel,
        arrayModel,
      });
      setDownloadFullDocUrl(downloadDocObj.downloadFullDocUrl);
      setDownloadFullDocLabel(downloadDocObj.downloadFullDocLabel);

      // !modelDocConfig && history.replace(gettingStartedPath);
      // TODO
      // mdString === 'undefined' &&
      getTechDocAction({ modelDocConfig, pageName, pageOpt, productName, model: arrayModel, dispatch });
    }
  }, [
    modelList,
    arrayModel,
    history,
    location,
    pageName,
    productName,
    mdString,
    pageOpt,
    simplivitymodel,
    hpeAlletraDHCImodel,
    dispatch,
  ]);

  useEffect(() => {
    if (props.pageProps && props.pageProps.func) {
      return props.pageProps.func();
    }
  });

  const pageCategory = '' || pageProps.category;
  return (
    <PageContentBox fill={true}>
      <PageTitleBox
        id="pageTitle1"
        responsive={props.responsive}
        title={Strings[pageName]}
        category={Strings[pageCategory]}
        onResponsiveMenuIconClick={() => toggleSideMenu(true, dispatch)}
        downloadUrl={downloadFullDocUrl}
        downloadTitle={downloadFullDocLabel}
      />
      <ContentBox direction="column">
        {videoUrl && <VideoBox videoUrl={videoUrl} id={`${pageName}-video`} />}
        <TechDocContent mdString={mdString} contentType={pageProps.contentType} />
      </ContentBox>

      <PageNavBar
        hide={mdString.length === 0}
        prevPage={pageProps.prevPage}
        nextPage={pageProps.nextPage}
        history={props.history}
        pageName={pageName}
      />
    </PageContentBox>
  );
}
